import React, { Component } from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'
// 引入action
// import { setPageTitle } from '../../store/actions.js'
import "./index.css"


class BoardTop extends Component {

    componentDidMount=()=> {
        const {props} = this
        var imgUrl =props.bgimg;
        var imgObject = new Image();
        var imgsdom = document.getElementById('imgs')
        imgObject.src = imgUrl;
        imgObject.onload = () => {
            imgsdom.src = imgUrl
            // self.img.setAttribute('class', 'thumbnails complete');
        }
        imgObject.onerror=()=>{
            imgsdom.src = props.errimg
        }
    }

    render() {
        const {props} = this
        return (
            <div className="title-box">
                <img id={'imgs'} style={{ width: "100%", display: "block",...props.imgstyle }} src={props.loadimg} />
                <div className="title" style={props.titlestyle}>
                    {props.rendertitle?props.rendertitle():<p className="title-text" style={{ textAlign: 'center' }}>{props.title?props.title:"留言板"}</p>}
                </div>

            </div>
        )
    }
}

export default connect()(BoardTop)